(function () {
  function getLocaleFromPath() {
    var path = window.location.pathname || "";
    if (path.indexOf("/de") === 0) return "de";
    if (path.indexOf("/nl") === 0) return "nl";
    return "en";
  }

  function getSaveWord() {
    var locale = getLocaleFromPath();
    if (locale === "nl") return "BESPAAR";
    if (locale === "de") return "SPARE";
    return "SAVE";
  }

  function translateBadge(badge) {
    if (!badge) return;

    var saveWord = getSaveWord();

    var text = (badge.textContent || "").trim();
    var match = text.match(/(\d+\s*%)/);
    var pct = match ? match[1].replace(/\s+/g, "") : "";

    var nextText = pct ? (saveWord + " " + pct) : saveWord;

    if (text !== nextText) {
      badge.setAttribute("data-i18n-updating", "1");
      badge.textContent = nextText;
      badge.setAttribute("data-i18n-applied", "1");
      badge.removeAttribute("data-i18n-updating");
    }
  }

  function translateAll() {
    var badges = document.querySelectorAll(".dbtfy-discount-badge.dbtfy-discount-saved");
    if (!badges.length) return;

    badges.forEach(function (b) {
      if (b.getAttribute("data-i18n-updating") === "1") return;
      translateBadge(b);
    });
  }

  var rafQueued = false;
  function scheduleTranslate() {
    if (rafQueued) return;
    rafQueued = true;
    requestAnimationFrame(function () {
      rafQueued = false;
      try { translateAll(); } catch (e) {}
    });
  }

  var observers = [];
  function observeContainer(el) {
    if (!el) return;

    var obs = new MutationObserver(function () {
      scheduleTranslate();
    });

    obs.observe(el, {
      subtree: true,
      childList: true,
      characterData: true
    });

    observers.push(obs);
  }

  function initObservers() {
    observers.forEach(function (o) {
      try { o.disconnect(); } catch (e) {}
    });
    observers = [];

    // 1) Observeer alle price wrappers (PDP plus featured product, mobile only, etc.)
    var priceWrappers = document.querySelectorAll(".price-wrapper");
    priceWrappers.forEach(function (el) {
      observeContainer(el);
    });

    // 2) Observeer product info containers als extra safety net
    var infoContainers = document.querySelectorAll(".product__info-container");
    infoContainers.forEach(function (el) {
      observeContainer(el);
    });

    // 3) Product grid (collecties)
    var grid = document.querySelector("#product-grid");
    if (grid) observeContainer(grid);

    // 4) Extra: featured product secties (deze vangt re renders van Debutify vaak perfect)
    var featuredSections = document.querySelectorAll(".section-featured-product, dbtfy-featured-product, product-info");
    featuredSections.forEach(function (el) {
      observeContainer(el);
    });
  }

  function run() {
    initObservers();
    scheduleTranslate();
    setTimeout(scheduleTranslate, 150);
    setTimeout(scheduleTranslate, 600);
  }

  document.addEventListener("DOMContentLoaded", run);
  window.addEventListener("load", run);

  document.addEventListener("shopify:section:load", run);
  document.addEventListener("shopify:section:reorder", run);
  document.addEventListener("shopify:section:select", run);

  document.addEventListener("variant:change", scheduleTranslate);

  document.addEventListener("change", function (e) {
    var el = e.target;
    if (!el) return;

    if (
      el.matches("variant-selects input, variant-selects select") ||
      el.matches(".product-form__input input, .product-form__input select") ||
      el.matches('[name*="Size"], [name*="Color"], [name^="Size"], [name^="Color"]')
    ) {
      scheduleTranslate();
    }
  });

  document.addEventListener("click", function (e) {
    var el = e.target;
    if (!el) return;

    if (
      el.closest("variant-selects") ||
      el.closest(".product-form__input") ||
      el.closest(".product-form__input--pill") ||
      el.closest(".product-form__input--swatch")
    ) {
      scheduleTranslate();
    }
  });
})();
